import { CssBaseline, ThemeProvider } from '@mui/material';
import { LibraryManagerProvider } from '@stores/LibraryManager/LibraryManager';
import { ModalProvider } from '@stores/ModalStore';
import { MomentThumbnailProvider } from '@stores/MomentThumbnail/MomentThumbnailStore';
import { UploadManagerProvider } from '@stores/UploadManager/UploadManager';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { appTheme } from './theme';

import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';

export const Entrypoint = () => {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <UploadManagerProvider>
        <LibraryManagerProvider>
          <ModalProvider>
            <MomentThumbnailProvider>
              <RouterProvider router={router} />
            </MomentThumbnailProvider>
          </ModalProvider>
        </LibraryManagerProvider>
      </UploadManagerProvider>
    </ThemeProvider>
  );
};
